import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Home = () => {
  const [currentTestimonialSlide, setCurrentTestimonialSlide] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [expandedGroups, setExpandedGroups] = useState({});
  const location = useLocation();
  
  useEffect(() => {
    // Handle hash navigation when coming from other pages
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  const SERVICE_GROUPS = [
    {
      id: "group-0",
      name: "Business Setup (Idea to Incorporation)",
      icon: "📊",
      items: [
        "Proprietorship Regn.",
        "Partnership Firm",
        "OPC Registration",
        "LLP Registration",
        "Private Ltd Company",
        "Section 8 Company",
        "Public Ltd Company",
        "Producer Company",
        "Indian Subsidiary",
      ],
    },
    {
      id: "group-1",
      name: "Compliance & Licensing",
      icon: "📝",
      items: [
        "Trust Registration",
        "Startup Registration",
        "FSSAI License Regn.",
        "IEC Code Registration",
        "Udyam Registration",
        "Shop Act Registration",
        "LEI Code Registration",
        "Trademark Registration",
        "Trade License Registration",
        "ICEGATE Registration",
      ],
    },
    {
      id: "group-2",
      name: "Taxation & Audit",
      icon: "✅",
      items: [
        "PF & ESIC Registration",
        "AD Code Registration",
        "APEDA Registration",
        "GST Registration",
        "Barcode Registration",
        "PT Return Filing",
        "PF & ESI Returns filing",
        "GST Return Filing",
        "Income Tax Filing",
        "TDS Return Filing",
        "ROC Annual Filing",
      ],
    },
    {
      id: "group-3",
      name: "CFO & Consulting",
      icon: "📈",
      items: [
        "Virtual CFO Services",
        "Bookkeeping Service",
        "Business Consultation",
        "Debt Syndication",
        "Internal Audit Services",
        "Forensic Services",
        "IPO Services",
      ],
    },
  ];

  const TESTIMONIALS = [
    {
      id: 1,
      name: "Harsh Talwar",
      position: "CEO of Cash For Phone",
      image: "/assets/images/Harsh Talwar.png",
      content: "I came to know about Akir Advisory from my friend. From the inception of my firm, their team have been good and reliable. I have recommended them to many entrepreneurs already.",
      rating: 5
    },
    {
      id: 2,
      name: "Gaurav Goel",
      position: "Designated Partner of Superkart International LLP",
      image: "/assets/images/Gaurav goel.jpeg",
      content: "Akir Advisory has supported us in the legal compliance and due diligence for the merger of our Family Business to consolidate in a LLP. We are grateful to receive constant support and guidance from Akir advisory.",
      rating: 5
    },
    {
      id: 3,
      name: "Praveen Choudhary",
      position: "Managing Director at Karam Cargo Logistic Private Limited",
      image: "/assets/images/Praveen ji.jpg",
      content: "Thank you very much for supporting our business activities - the Business Solution & suggestions your team providing us will continue to guide our team to upgrade our system. I am grateful to Akir Advisory for assisting with their valuable business advisory services.",
      rating: 5
    },
    {
      id: 4,
      name: "Kunal Arora",
      position: "Owner of M/S K Nine Apparels",
      image: "/assets/images/Kunal Arora.jpg",
      content: "For somebody who is not aware of the procedures for GST registration and compliances applicable, this would be the best place to checkout. They assist me with every single detail and replied to all the queries. Thank you for providing service in a very professional manner.",
      rating: 5
    },
    {
      id: 5,
      name: "Jeevesh Kumar",
      position: "CEO of Greenscape Eco Management Private Limited",
      image: "/assets/images/Jeevesh Kumar.png",
      content: "I highly recommend Akir Advisory for anybody who is planning to set up a company in India. The professionalism they displayed made me more attracted to them. let me use this opportunity to commend CA Sonu Jha, Overall good and satisfied. Keep it up.",
      rating: 5
    },
    {
      id: 6,
      name: "Jitender Bhatia",
      position: "CEO & Director of Davabikri",
      image: "/assets/images/Mr Jitender Bhatia Director.jpeg",
      content: "Akir Advisory revolutionized our company's operations through their expert digitalization and process automation services. Their professionalism, deep understanding of our needs, and cutting-edge solutions have boosted productivity and efficiency. We highly recommend Akir Advisory for transformative business solutions.",
      rating: 5
    },
    {
      id: 7,
      name: "Kripal Singh",
      position: "Operation Head and Director of Vista Lightscape Pvt. Ltd.",
      image: "/assets/images/Kirpal Singh.jpeg",
      content: "Thank you very much for supporting our business activities - the Business Solution & suggestions your team providing us will continue to guide our team to upgrade our system. I am grateful to Akir Advisory for assisting with their valuable business advisory services.",
      rating: 5
    },
    {
      id: 8,
      name: "Sachin Verma",
      position: "Founder and Operation Head at Aariya Regulatory Services Pvt. Ltd.",
      image: "/assets/images/Sachin Verma.png",
      content: "Aariya Regulatory is a consistent customer and appreciates the relationship we have with this team. They are fast, reliable and attentive. We have been using them for a couple of years now and we will continue to have them as part of our business.",
      rating: 5
    }
  ];

  // Toggle service group visibility
  const toggleMoreServices = (groupId) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  // Testimonial carousel functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonialSlide((prev) => (prev + 1) % 2);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextTestimonial = () => {
    setCurrentTestimonialSlide((prev) => (prev + 1) % 2);
  };

  const prevTestimonial = () => {
    setCurrentTestimonialSlide((prev) => (prev - 1 + 2) % 2);
  };

  const goToSlide = (slideIndex) => {
    setCurrentTestimonialSlide(slideIndex);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Capture all form data including the honeypot
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      // Send data to your Hostinger PHP script
      const response = await fetch("https://akiradvisory.in/send_mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setFormStatus('success');
        e.target.reset(); // Clear the form on success
      } else {
        setFormStatus('error');
      }
    } catch (error) {
      console.error("Submission error:", error);
      setFormStatus('error');
    } finally {
      setIsSubmitting(false);
      // Clear status message after 5 seconds
      setTimeout(() => setFormStatus(''), 5000);
    }
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className="text-yellow-400">
        {index < rating ? '★' : '☆'}
      </span>
    ));
  };

  // Split testimonials into two slides of 4 each
  const testimonialSlides = [
    TESTIMONIALS.slice(0, 4),
    TESTIMONIALS.slice(4, 8)
  ];

  // Function to create slug for service links
 const createSlug = (text) => {
  // If is a group title, return the same
  if (text.includes("Idea to Incorporation")) {
    return "idea-to-incorporation";
  }

  // Convert & → and
  text = text.replace(/&/g, "and");

  return text
    .toLowerCase()            // lowercase
    .replace(/\./g, "")       // remove dots
    .replace(/,/g, "")        // remove commas
    .replace(/\s+/g, "-")     // spaces → hyphens
    .replace(/[^a-z0-9-]/g, "") // remove special chars
    .replace(/-+/g, "-")      // avoid multiple hyphens
    .trim();                  // clean edges
};

  // Render service items with show more/less functionality
  const renderServiceItems = (group) => {
    const initialItems = group.items.slice(0, 7);
    const hiddenItems = group.items.slice(7);
    const isExpanded = expandedGroups[group.id];

    return (
      <>
        {initialItems.map((item, index) => (
          <li key={index} className="flex items-start">
            <span className="text-blue-500 mr-2">→</span>
            <a 
              href={`/${createSlug(item)}`} 
              className="text-gray-600 hover:text-blue-500 hover:underline transition duration-150 ease-in-out"
            >
              {item}
            </a>
          </li>
        ))}
        {hiddenItems.map((item, index) => (
          <li 
            key={index + initialItems.length} 
            className={`flex items-start transition-all duration-300 ${isExpanded ? 'block' : 'hidden'}`}
          >
            <span className="text-blue-500 mr-2">→</span>
            <a 
              href={`/${createSlug(item)}`} 
              className="text-gray-600 hover:text-blue-500 hover:underline transition duration-150 ease-in-out"
            >
              {item}
            </a>
          </li>
        ))}
        {group.items.length > 7 && (
          <li 
            onClick={() => toggleMoreServices(group.id)}
            className="text-blue-500 font-medium cursor-pointer hover:underline pt-1 transition-colors duration-200"
          >
            {isExpanded ? '− Show Less' : `+ ${hiddenItems.length} More Services`}
          </li>
        )}
      </>
    );
  };

  return (
    <main>
      {/* Hero Section */}
      <section id="home" className="py-20 md:py-32 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-gray-900 leading-tight">
            <span className="block">Online Business Advisory Services</span>
            <span className="block text-blue-600 mt-2">
              Simplifying Legal & Regulatory Requirements.
            </span>
          </h1>
          <p className="mt-6 text-lg text-gray-600 max-w-3xl mx-auto">
            Akir Advisory is India's leading platform, helping entrepreneurs
            start and manage their businesses by making critical services like
            legal compliance cost-effective, high quality, and accessible for all.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <a
              href="#contact"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-white bg-blue-600 hover:bg-blue-700 transition duration-150 ease-in-out transform hover:scale-105"
            >
              Get a Quote Now
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center px-6 py-3 border border-blue-600 text-base font-medium rounded-full text-blue-600 bg-white hover:bg-blue-50 transition duration-150 ease-in-out transform hover:scale-105"
            >
              Explore All 40+ Services
            </a>
          </div>
        </div>
      </section>

      {/* Impact Stats Section */}
      <section id="impact" className="py-16 bg-blue-600/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div className="flex flex-col items-center p-4">
              <p className="text-4xl font-extrabold text-white">910+</p>
              <p className="mt-2 text-sm font-medium text-blue-100 uppercase tracking-wider">
                Happy Clients
              </p>
            </div>
            <div className="flex flex-col items-center p-4">
              <p className="text-4xl font-extrabold text-white">1300+</p>
              <p className="mt-2 text-sm font-medium text-blue-100 uppercase tracking-wider">
                Completed Assignments
              </p>
            </div>
            <div className="flex flex-col items-center p-4">
              <p className="text-4xl font-extrabold text-white">7+</p>
              <p className="mt-2 text-sm font-medium text-blue-100 uppercase tracking-wider">
                Winning Awards
              </p>
            </div>
            <div className="flex flex-col items-center p-4">
              <p className="text-4xl font-extrabold text-white">50+</p>
              <p className="mt-2 text-sm font-medium text-blue-100 uppercase tracking-wider">
                Employees
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-20">
            <div className="text-center mb-10">
              <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                Top Business Structures
              </h2>
              <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Get Started With Your Company Registration
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-gray-50 p-6 rounded-xl shadow-lg border-l-4 border-blue-600 flex flex-col">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Private Limited Company Registration
                </h3>
                <p className="text-gray-600 mb-4 flex-grow">
                  Start-ups and businesses with higher growth aspirations
                  popularly prefer Private Company registration as a suitable
                  business structure governed by the Ministry of Corporate
                  Affairs (MCA).
                </p>
                <a
            href="/private-ltd-company"
            className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 transition"
          >
                  Register Now →
                </a>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl shadow-lg border-l-4 border-blue-600 flex flex-col">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Limited Liability Partnership Registration (LLP)
                </h3>
                <p className="text-gray-600 mb-4 flex-grow">
                  A Limited Liability Partnership (LLP) is a legal entity
                  registered under the LLP Act, 2008. It acts as a middle ground
                  between a Company and a Partnership, offering the advantage of
                  limited liability with the flexibility of a Partnership.
                </p>
                <a
            href="/llp-registration"
            className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 transition"
          >
                  Register Now →
                </a>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl shadow-lg border-l-4 border-blue-600 flex flex-col">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  One Person Company Registration (OPC)
                </h3>
                <p className="text-gray-600 mb-4 flex-grow">
                  One Person Company (OPC) is a company where only one
                  shareholder holds 100% of the stake and acts as a director.
                  Entrepreneurs who prefer single-person control in the entity
                  can opt for this structure.
                </p>
                <a
            href="/opc-registration"
            className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 transition"
          >
                  Register Now →
                </a>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl shadow-lg border-l-4 border-blue-600 flex flex-col">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Startup Registration In India
                </h3>
                <p className="text-gray-600 mb-4 flex-grow">
                  A startup is a newly established business, usually small,
                  started by one or a group of individuals with innovation. The
                  business either develops a new product/service or redevelops a
                  current product/service into something better.
                </p>
                <a
            href="/startup-registration"
            className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-full text-white bg-blue-600 hover:bg-blue-700 transition"
          >
                  Register Now →
                </a>
              </div>
            </div>
          </div>

          <div className="border-t pt-16">
            <div className="text-center mb-16">
              <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                One-Stop Solution
              </h2>
              <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Complete Business Compliance & Advisory Services
              </p>
              <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
                Focus on your core business; we manage the complexities of
                legal, regulatory, and financial compliance for you.
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-8">
              {SERVICE_GROUPS.map((group) => (
                <div key={group.id} className="p-6 bg-gray-50 rounded-xl shadow-lg border-t-4 border-blue-500 transition duration-300 ease-in-out hover:shadow-xl">
                  <div className="flex items-center space-x-3 mb-4">
                    <span className="text-2xl">{group.icon}</span>
                    <h3 className="text-xl font-bold text-gray-900">{group.name}</h3>
                  </div>
                  <ul className="space-y-2 text-sm text-gray-600">
                    {renderServiceItems(group)}
                  </ul>
                  <a href="#contact" className="mt-4 inline-block text-blue-600 hover:text-blue-800 font-medium text-sm">
                    View Details →
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-12 items-center">
            <div className="order-2 lg:order-1">
              <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                Our Mission
              </h2>
              <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Dedication to the Entrepreneurial Journey
              </p>
              <p className="mt-4 text-lg text-gray-600">
                Akir Advisory is India's online business advisory services
                platform dedicated to helping the entrepreneur by simplifying
                the legal and regulatory requirements. We believe that access to
                critical services should be just a click away. Our team is
                working to bring high-quality legal, financial, and compliance
                expertise online, making it cost-effective, high quality, and
                accessible for all.
              </p>
              <p className="mt-4 text-lg text-gray-600 font-semibold">
                Providing the best business solutions with 20+ years of
                collective experience.
              </p>
              <a
                href="#contact"
                className="mt-8 inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-md text-white bg-blue-600 hover:bg-blue-700 transition duration-150 ease-in-out"
              >
                Consult Our Experts
              </a>
            </div>
            <div className="order-1 lg:order-2 mt-10 lg:mt-0">
              <div className="bg-white p-6 rounded-xl shadow-2xl">
                <img
                  src="https://placehold.co/600x400/1E3A8A/ffffff?text=Trusted+Advisory+Partner"
                  alt="A symbol representing financial trust and partnership."
                  className="w-full h-auto object-cover rounded-lg"
                />
              </div>
            </div>
          </div>

          {/* Team Section */}
          <div className="mt-20 pt-10 border-t border-gray-300">
            <h3 className="text-center text-3xl font-extrabold tracking-tight text-gray-900 mb-4">
              Meet Our Leadership Team
            </h3>
            <p className="text-center text-lg text-gray-600 mb-12">
              Our experts guide you through every regulatory challenge.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-xl shadow-xl text-center transition duration-300 hover:shadow-2xl hover:border-b-4 hover:border-blue-600">
                <img
                  src="/assets/images/1_Sonu.jpg"
                  alt="Sonu Jha"
                  className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-4 border-blue-500/50"
                />
                <h4 className="text-xl font-semibold text-gray-900">
                  Sonu Jha
                </h4>
                <p className="text-blue-600 font-medium text-sm mt-1">
                  Founder & CEO
                </p>
                <p className="text-gray-500 mt-3 text-sm">
                  20+ years in finance and corporate law, driving strategic vision.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-xl text-center transition duration-300 hover:shadow-2xl hover:border-b-4 hover:border-blue-600">
                <img
                  src="https://placehold.co/100x100/3B82F6/ffffff?text=PV"
                  alt="Priya Verma"
                  className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-4 border-blue-500/50"
                />
                <h4 className="text-xl font-semibold text-gray-900">Priya Verma</h4>
                <p className="text-blue-600 font-medium text-sm mt-1">
                  Head of Taxation
                </p>
                <p className="text-gray-500 mt-3 text-sm">
                  Expert in GST, Income Tax, and compliance across various sectors.
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-xl text-center transition duration-300 hover:shadow-2xl hover:border-b-4 hover:border-blue-600">
                <img
                  src="https://placehold.co/100x100/3B82F6/ffffff?text=AS"
                  alt="Amit Singh"
                  className="w-24 h-24 rounded-full mx-auto mb-4 object-cover border-4 border-blue-500/50"
                />
                <h4 className="text-xl font-semibold text-gray-900">Amit Singh</h4>
                <p className="text-blue-600 font-medium text-sm mt-1">
                  Legal & Regulatory Advisor
                </p>
                <p className="text-gray-500 mt-3 text-sm">
                  Specializing in MCA, LLP registrations, and IP protection services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Client Success Stories
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Our Clients Say
            </p>
            <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
              Don't just take our word for it. Here's what entrepreneurs and business owners have to say about their experience with Akir Advisory.
            </p>
          </div>

          {/* Testimonial Carousel Container */}
          <div className="relative">
            {/* Carousel */}
            <div className="overflow-hidden">
              <div 
                className="flex transition-transform duration-500 ease-in-out" 
                style={{ transform: `translateX(-${currentTestimonialSlide * 100}%)` }}
              >
                {testimonialSlides.map((slide, slideIndex) => (
                  <div key={slideIndex} className="w-full flex-shrink-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {slide.map((testimonial) => (
                      <div key={testimonial.id} className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-blue-600">
                        <div className="flex items-center mb-4">
                          <img 
                            src={testimonial.image} 
                            alt={testimonial.name} 
                            className="w-12 h-12 rounded-full object-cover mr-4"
                            onError={(e) => {
                              e.target.src = `https://placehold.co/100x100/3B82F6/ffffff?text=${testimonial.name.charAt(0)}`;
                            }}
                          />
                          <div>
                            <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                            <p className="text-sm text-gray-600">{testimonial.position}</p>
                          </div>
                        </div>
                        <div className="flex text-yellow-400 mb-3">
                          {renderStars(testimonial.rating)}
                        </div>
                        <p className="text-gray-700 italic text-sm">
                          "{testimonial.content}"
                        </p>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center mt-8 space-x-3">
              {testimonialSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    currentTestimonialSlide === index ? 'bg-blue-600 w-8' : 'bg-blue-300'
                  }`}
                />
              ))}
            </div>

            {/* Navigation Arrows */}
            <button 
              onClick={prevTestimonial}
              className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 bg-white rounded-full p-2 shadow-lg hover:bg-blue-50 transition duration-200"
            >
              <span className="text-blue-600">←</span>
            </button>
            <button 
              onClick={nextTestimonial}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 bg-white rounded-full p-2 shadow-lg hover:bg-blue-50 transition duration-200"
            >
              <span className="text-blue-600">→</span>
            </button>
          </div>

          {/* Statistics Row */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-3xl font-bold text-blue-600">98%</div>
              <div className="text-sm text-gray-600 mt-2">Client Satisfaction Rate</div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-3xl font-bold text-blue-600">24-48</div>
              <div className="text-sm text-gray-600 mt-2">Hours Average Response Time</div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-3xl font-bold text-blue-600">99%</div>
              <div className="text-sm text-gray-600 mt-2">On-Time Delivery Rate</div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <div className="text-3xl font-bold text-blue-600">4.9/5</div>
              <div className="text-sm text-gray-600 mt-2">Average Rating</div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center mt-12">
  <Link 
    to="/testimonials" 
    className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-white bg-blue-600 hover:bg-blue-700 transition duration-150 ease-in-out transform hover:scale-105"
  >
    <span className="mr-2">💬</span> Read All Testimonials
  </Link>
</div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-16">
      <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
        Start Your Journey with a no-obligation initial consultation
      </h2>
      <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
        Get Expert Consultation
      </p>
      <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
        Complete the form below to arrange a
        <strong> confidential, no-obligation initial consultation</strong> with Akir advisory's
        experts.
      </p>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      {/* Contact Information Section - Left */}
      <div className="lg:col-span-1">
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl shadow-lg h-full">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Get in Touch</h3>
          
          <div className="space-y-8">
            {/* Phone */}
            <div className="flex items-start space-x-4 group">
              <div className="p-3 bg-blue-600 rounded-xl shadow-md group-hover:bg-blue-700 transition duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-white">
                  <path d="M22 16.92v3.08a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-5.6-5.6A19.79 19.79 0 0 1 2 4.18 2 2 0 0 1 4.1 2h3.08a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-1">Call Us</h4>
                <a 
                  href="tel:+919873030848" 
                  className="text-blue-600 hover:text-blue-800 font-medium text-lg transition duration-200"
                >
                  +91-9873030848
                </a>
                <p className="text-gray-600 text-sm mt-1">Mon-Fri: 9:00 AM - 6:00 PM</p>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start space-x-4 group">
              <div className="p-3 bg-blue-600 rounded-xl shadow-md group-hover:bg-blue-700 transition duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-white">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-1">Email Us</h4>
                <a 
                  href="mailto:info@akiradvisory.in" 
                  className="text-blue-600 hover:text-blue-800 font-medium text-lg transition duration-200"
                >
                  info@akiradvisory.in
                </a>
                <p className="text-gray-600 text-sm mt-1">We respond within 24 hours</p>
              </div>
            </div>

            {/* Address */}
            <div className="flex items-start space-x-4 group">
              <div className="p-3 bg-blue-600 rounded-xl shadow-md group-hover:bg-blue-700 transition duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-white">
                  <path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-1">Visit Us</h4>
                <p className="text-gray-700 font-medium">
                  357, Surya Nagar, Phase-II<br />
                  Faridabad, Haryana
                </p>
                <a 
                  href="https://www.google.com/maps/place/28%C2%B028'49.3%22N+77%C2%B019'57.2%22E/@28.4803579,77.3299688,999m/data=!3m2!1e3!4b1!4m4!3m3!8m2!3d28.4803579!4d77.3325437!5m1!1e1?hl=en&entry=ttu&g_ep=EgoyMDI1MTExNy4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium text-sm mt-2 transition duration-200"
                >
                  Open in Google Maps
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="ml-1">
                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                    <polyline points="15 3 21 3 21 9"></polyline>
                    <line x1="10" y1="14" x2="21" y2="3"></line>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div className="mt-10 pt-8 border-t border-blue-200">
            <h4 className="text-lg font-semibold text-gray-800 mb-3">Business Hours</h4>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">Monday - Friday</span>
                <span className="font-medium text-gray-800">9:00 AM - 6:00 PM</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Saturday</span>
                <span className="font-medium text-gray-800">10:00 AM - 2:00 PM</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Sunday</span>
                <span className="font-medium text-gray-800">Closed</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Section - Right */}
      <div className="lg:col-span-2">
        <div className="bg-white p-8 rounded-2xl shadow-xl border border-blue-500/10 h-full">
          {formStatus === 'success' && (
          <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-start gap-3 mb-6">
          <span className="text-lg mt-0.5">✅</span>
          <div>
          <p className="font-semibold">
           Thank you.
          </p>
          <p>
          Your request for an <strong>initial consultation</strong> has been received.
          Our advisory team will connect with you shortly.
          </p>
          </div>
          </div>
          )}

          <h3 className="text-2xl font-bold text-gray-900 mb-6">Request a Consultation</h3>
          
          <form onSubmit={handleFormSubmit} className="space-y-6">
          <input type="text" name="website_hp" style={{ display: 'none' }} tabIndex="-1" autoComplete="off" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                  placeholder="John Doe"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                  placeholder="you@company.com"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                  placeholder="+91-9876543210"
                />
              </div>
              <div>
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                  Company Name (Optional)
                </label>
                <input
                  type="text"
                  name="company"
                  id="company"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                  placeholder="Your Company"
                />
              </div>
            </div>

            <div>
              <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-2">
                Service Required *
              </label>
              <select
                name="service"
                id="service"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
              >
                <option value="">Select a service</option>
                <option value="Company Registration">Company Registration</option>
                <option value="LLP Registration">LLP Registration</option>
                <option value="GST Registration & Filing">GST Registration & Filing</option>
                <option value="Trademark Registration">Trademark Registration</option>
                <option value="Taxation Services">Taxation Services</option>
                <option value="Compliance & Licensing">Compliance & Licensing</option>
                <option value="Virtual CFO Services">Virtual CFO Services</option>
                <option value="Other">Other Services</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                How can we help you? *
              </label>
              <textarea
                name="message"
                id="message"
                rows="5"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                placeholder="Please describe your requirements in detail (e.g., LLP registration, GST filing, compliance needs, etc.)"
              ></textarea>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full flex justify-center items-center px-6 py-4 border border-transparent rounded-lg shadow-lg text-lg font-semibold text-white transition duration-150 bg-blue-600 hover:bg-blue-700 transform hover:scale-[1.02] disabled:bg-blue-400 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                  Sending...
                </>
              ) : (
                <>
                  <span className="mr-3">📨</span>
                  Request an Initial Consultation
                </>
              )}
            </button>

            <p className="text-center text-gray-500 text-sm mt-4">
              By submitting this form, you agree to our Privacy Policy. We'll never share your information.
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
    </main>
  );
};

export default Home;